import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks/redux-hooks";
import { setSEOSettings } from "../../store/slices/main";

const Сontests = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const navigateAndSetSEOSettings = (
    link: string,
    appTitle: string,
    appDescription: string,
    appImg: string
  ) => {
    navigate(`${link}`);
    dispatch(
      setSEOSettings({
        appTitle,
        appDescription,
        appImg,
      })
    );
  };

  return (
    <div
      onClick={() => {
        navigateAndSetSEOSettings(
          "/contests",
          "Конкурси",
          "Ласкаво просимо до розділу конкурсів та розіграшів від Радіо «Сільпо»! Приєднуйтесь до наших конкурсів артистів, проявляйте свій талант і дайте світу почути вашу музику! Ваші талант і творчість будуть оцінені нашими експертами та шанувальниками музики.",
          ""
        );
      }}
      className="flex items-center pb-[2rem] px-5 cursor-pointer md:px-0"
    >
      <h2 className="text-xl pr-2.5 text-black font-bold">Конкурси</h2>
      <span className="hidden text-[13px] pt-1 opacity-70 hover:opacity-100 md:block">
        Переглянути всі
      </span>
    </div>
  );
};

export default Сontests;
